import { api, paramsSerializer, paramsToQuery } from "@common/urls";
import axios from "axios";

export const fetchPins = async (types: string | string[]): Promise<number[]> => {
  const response = await axios.get(
    api.mapPoints.get(),
    {
      params: paramsToQuery({
        type: types,
      }),
      paramsSerializer
    }
  );

  if (response?.data?.length) {
    const points = response.data;

    return points;
  }

  return [];
}

export const fetchPointsPlaces = async (params: any): Promise<any[]> => {
  const response = await axios.get(api.places.points.get(), {
    params: paramsToQuery(params),
    paramsSerializer
  }
  );

  if (response?.data?.length) {
    return response.data;
  }

  return [];
}
